import * as React from 'react';

import { Typography, Typography2 } from '@coursera/cds-core';

import DegreesMartechExperiments from 'bundles/epic/clients/DegreesMartech';
import type { EoiSectionPropTypes } from 'bundles/xddp/types';

import _t from 'i18n!nls/xddp';

import 'css!bundles/xddp/components/__styles__/eoi/EoiHeader';

type Props = {
  section: EoiSectionPropTypes;
  showDescription: boolean;
};

const EoiHeader = ({ section, showDescription }: Props) => {
  const shouldShowRequiredEoiUpenn = DegreesMartechExperiments.get('shouldShowRequiredEoiUpenn');
  const getTitle = (): string => {
    if (shouldShowRequiredEoiUpenn && section.sectionType !== 'terminalSection') {
      return _t('Get started');
    } else {
      return section.title;
    }
  };

  return (
    <div className="rc-EoiHeader">
      <Typography variant="h1semibold">{getTitle()}</Typography>
      {showDescription && section.description && (
        <Typography2 component="p" variant="bodySecondary" className="p-t-1" color="supportText">
          {section.description}
        </Typography2>
      )}
    </div>
  );
};

export default EoiHeader;
